import gql from 'graphql-tag'

export const GET_VEHICLE_GROUPS = gql`
  query Vgroups($filter: GetVgroupsInput) {
    vgroups(filter: $filter) {
      isSuccessful
      message
      vgroups {
        name
        totalVehicle
        hasRelation
        id
        companyId
        vehicleList {
          id
        }
      }
    }
  }
`

export const GET_VEHICLE_GROUP_DETAIL = gql`
  query Vgroup($filter: GetVgroupInputType!) {
    vgroup(filter: $filter) {
      isSuccessful
      message
      vgroup {
        id
        companyId
        company {
          name
        }
        name
        totalVehicle
        hasRelation
        vehicleList {
          id
          licensePlate
          imei
          vehicleType {
            category
            manufacturer
            model
            type
            icon
          }
        }
      }
    }
  }
`

export const UPDATE_VEHICLE_GROUP = gql`
  mutation UpdateVgroup($input: UpdateVgroupInput!) {
    updateVgroup(input: $input) {
      isSuccessful
      message
    }
  }
`

export const CREATE_VEHICLE_GROUP = gql`
  mutation CreateVgroup($input: CreateVgroupInput!) {
    createVgroup(input: $input) {
      isSuccessful
      message
    }
  }
`

export const DELETE_VEHICLE_GROUP = gql`
  mutation DeleteVgroup($input: DeleteVgroupInput!) {
    deleteVgroup(input: $input) {
      isSuccessful
      message
    }
  }
`
